import {
  EfsMelcoEfsModelsFormat,
  Drawer as DrawerType,
} from "melco-shared-logic";
import { Drawer } from "melco-ui";
import { useTranslation } from "react-i18next";
import { AddOrEditDataMapping } from "./AddOrEditDataMapping";

type DataMappingDrawerProps = {
  drawer: DrawerType;
  inputFormat: EfsMelcoEfsModelsFormat;
  editDataMappingId: string | undefined;
};

export const DataMappingDrawer: React.FC<DataMappingDrawerProps> = ({
  drawer,
  inputFormat,
  editDataMappingId,
}) => {
  const { t } = useTranslation();

  const { closeDrawer, isDrawerOpen } = drawer;

  return (
    <Drawer
      title={t(
        `dataMappings.actions.${
          editDataMappingId == null ? "add" : "edit"
        }.title`
      )}
      placement="right"
      width={1000}
      closable={true}
      onClose={closeDrawer}
      open={isDrawerOpen}
    >
      <AddOrEditDataMapping
        key={
          editDataMappingId == null
            ? "add"
            : `edit-data-mapping-${editDataMappingId}`
        }
        drawer={drawer}
        inputFormat={inputFormat}
        dataMappingId={editDataMappingId}
        formMode={editDataMappingId == null ? "add" : "edit"}
      />
    </Drawer>
  );
};
